import { validateTIN } from './requests';

export const validateTINSaga = async ({ action }) => {
  return validateTIN(action.payload);
};
